import { ERole } from "modules/Accounts/types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectedAccountSelector } from "store/selectors/selectors";
import { RootState } from "store/store";

const useIsAdmin = () => {
  const selectedAccount = useSelector(
    selectedAccountSelector
  );
  return useMemo(() => {
    if (!selectedAccount) return false;
    const member = selectedAccount.member;
    if (member.roles.includes(ERole.ADMIN)) {
      return true;
    }
    return false;
  }, [selectedAccount]);
};

export default useIsAdmin;
